import { render, staticRenderFns } from "./task.vue?vue&type=template&id=662b197f&"
import script from "./task.vue?vue&type=script&lang=js&"
export * from "./task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hugomarcelino/projects/cob/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('662b197f')) {
      api.createRecord('662b197f', component.options)
    } else {
      api.reload('662b197f', component.options)
    }
    module.hot.accept("./task.vue?vue&type=template&id=662b197f&", function () {
      api.rerender('662b197f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/recordm/fields/task.vue"
export default component.exports